module.exports = __webpack_public_path__ + "assets/img/line-4-3.0b2a3266.png";